// extracted by mini-css-extract-plugin
export default {"wrapper":"notfound_wrapper__Luhim"};